import { loadPhoneInputConfiguration } from 'features/shared/forms/components/phoneInput/phoneInputConfig';
import ValidationService from '../ValidationService';

export default class PhoneNumberValidator {
  // default regex is for czech phone number (+420)
  private readonly _defaultRegex = /^[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/;
  private readonly _validationService: ValidationService;

  constructor() {
    this._validationService = new ValidationService();
  }

  validate(number: string, prefix: string): boolean {
    let regex = this.getRegex(prefix);
    return this._validationService.validateRegex(number, regex);
  }

  private getRegex(prefix: string) : RegExp {
    const configs = loadPhoneInputConfiguration();
    const inputCofing = configs.find(x => x.prefix == prefix);

    return inputCofing ? new RegExp(inputCofing.regex) : this._defaultRegex;
  }
}